"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _flatten = _interopRequireDefault(require("lodash/flatten"));

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _dateTimeString = require("./date-time-string");

var _dateString = require("./date-string");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * Organizes an array of distributed events. Returns an array of events with enhanced values.
 * Check the bottom of the file for an example input/output.
 */
var organizeDistributedEvents = function organizeDistributedEvents(_ref) {
  var distributedEvents = _ref.distributedEvents,
      timeRangeStart = _ref.timeRangeStart,
      timeRangeEnd = _ref.timeRangeEnd,
      _ref$overlapBy = _ref.overlapBy,
      overlapBy = _ref$overlapBy === void 0 ? "day" : _ref$overlapBy;
  // Here we keep track of what events have been placed in which row.
  var rows = [[]]; // Helper functions to test if an event should be clipped

  var startedBefore = function startedBefore(event) {
    return (0, _dateTimeString.isBefore)(event.start, timeRangeStart);
  };

  var finishesAfter = function finishesAfter(event) {
    return (0, _dateTimeString.isBefore)(timeRangeEnd, event.end);
  }; // The method we use to determine if two ranges overlap. If overlapBy is "time", take time
  // into account. Else, only consider if the ranges overlap within a day of each other.


  var overlap = overlapBy === "time" ? _dateTimeString.isWithinRange : _dateString.isWithinRange;
  distributedEvents // Filter out events that occur outside our time range
  .filter(function (event) {
    return event.start === timeRangeStart || overlap(event.start, timeRangeStart, timeRangeEnd) || overlap(timeRangeStart, event.start, event.end);
  }) // Sort the events so the first chronological event is always in the first row
  .sort(function (a, b) {
    return (0, _dateTimeString.isBefore)(a.start, b.start) ? -1 : 1;
  }) // Give each event a start/end date clipped to the time range
  .map(function (event) {
    var clipStart = startedBefore(event);
    var clipEnd = finishesAfter(event);
    return _objectSpread(_objectSpread({}, event), {}, {
      clipStart: clipStart,
      clipEnd: clipEnd,
      startDate: clipStart ? timeRangeStart : event.start,
      endDate: clipEnd ? timeRangeEnd : event.end,
      // TODO: 6.x remove clipLeft and clipRight
      clipLeft: clipStart,
      clipRight: clipEnd
    });
  }) // Organize the events into rows
  .forEach(function (event) {
    // Find the first row where the event does not overlap with any events
    // currently in that row
    var row = (0, _findIndex["default"])(rows, function (rowEvents) {
      return rowEvents.every(function (rowEvent) {
        return (// First check if the start dates / end dates are the same (equality
          // checks like this are cheap and, if they return false, we get to skip
          // the more expensive `overlap` checks!)
          event.startDate !== rowEvent.startDate && event.endDate !== rowEvent.endDate && !overlap(event.startDate, rowEvent.startDate, rowEvent.endDate) && !overlap(event.endDate, rowEvent.startDate, rowEvent.endDate)
        );
      });
    }); // If no row exists, push a new row

    if (row === -1) rows.push([_objectSpread(_objectSpread({}, event), {}, {
      row: rows.length
    })]); // Else, add event to current row
    else rows[row].push(_objectSpread(_objectSpread({}, event), {}, {
      row: row
    }));
  }); // Flatten the array of arrays now that we've added the row information

  return (0, _flatten["default"])(rows);
};

var _default = organizeDistributedEvents;
/**
 
  // organize distributed events inside a time range
  organizeDistributedEvents({
    timeRangeStart: "2018-12-20 00:00",
    timeRangeEnd: "2018-12-25 24:00",
    distributedEvents: [
      { start: "2018-12-20 00:00", end: "2018-12-23 11:00" },
      { start: "2018-12-23 12:00", end: "2018-12-24 12:00" },
      { start: "2018-12-10 12:00", end: "2018-12-28 00:00" },
      { start: "2018-01-01 12:00", end: "2018-01-02 24:00" },
    ],
  })

 // returns filtered events with enhanced values: startDate, endDate,
 // clipStart, clipEnd, row
 [{
    start: "2018-12-10 12:00", 
    end: "2018-12-28 00:00",
    startDate: "2018-12-20 00:00", 
    endDate: "2018-12-25 24:00",
    clipStart: true, 
    clipEnd: true,
    row: 0,
  },
  {
    start: "2018-12-20 00:00", 
    end: "2018-12-23 11:00",
    startDate: "2018-12-20 00:00", 
    endDate: "2018-12-23 11:00",
    clipStart: false, 
    clipEnd: false,
    row: 1,
  },
  {
    start: "2018-12-23 12:00", 
    end: "2018-12-24 12:00",
    startDate: "2018-12-23 12:00", 
    endDate: "2018-12-24 12:00",
    clipStart: false, 
    clipEnd: false,
    row: 1,
  }]

 */

exports["default"] = _default;